module.exports = __webpack_public_path__ + "static/media/external-link-alt.0bcce3bf.svg";